/**
 * TypingIndicator Component
 * Premium animated typing indicator with gradient dots
 */
import React from "react";

export const TypingIndicator: React.FC = () => {
  return (
    <div className="flex justify-start mb-4 animate-fade-up">
      <div className="bg-slate-800/80 backdrop-blur-sm rounded-2xl px-5 py-3 border border-slate-700/50">
        <div className="flex items-center gap-1.5">
          <div
            className="w-2 h-2 rounded-full bg-gradient-to-r from-primary-400 to-accent-400 animate-bounce"
            style={{ animationDelay: "0ms", animationDuration: "0.8s" }}
          />
          <div
            className="w-2 h-2 rounded-full bg-gradient-to-r from-primary-400 to-accent-400 animate-bounce"
            style={{ animationDelay: "150ms", animationDuration: "0.8s" }}
          />
          <div
            className="w-2 h-2 rounded-full bg-gradient-to-r from-primary-400 to-accent-400 animate-bounce"
            style={{ animationDelay: "300ms", animationDuration: "0.8s" }}
          />
        </div>
      </div>
    </div>
  );
};
